import { useMemo } from 'react';
import { useRuntimeConfig } from '../runtimeConfig';
// Shared company settings read from the SSR runtime.
// These values are stored in the database, are not managed through the frontend Settings UI,
// and are needed across multiple screens.
// Using a hook keeps access consistent and avoids prop drilling or an extra company-setting query.
// Keep this hook limited to shared runtime-backed values such as applicationName and company date/time formats.

const useCompanyRuntimeSettings = () => {
    const {
        applicationName,
        common: {
            formats: { datePickerFormat, timePickerFormat, dateTimePickerFormat, dateFormatForTemplate },
            currency,
        },
    } = useRuntimeConfig();

    return useMemo(
        () => ({
            applicationName,
            datePickerFormat,
            timePickerFormat,
            dateTimePickerFormat,
            dateFormatForTemplate,
            currency,
        }),
        [applicationName, datePickerFormat, timePickerFormat, dateTimePickerFormat, dateFormatForTemplate, currency]
    );
};

export default useCompanyRuntimeSettings;
